import {
	ORDERLOCATIONS,
	ORDERLOCATIONS_ADD,
	ORDERLOCATIONS_DELETE,
	ORDERLOCATIONS_EDIT,
	ORDERLOCATIONS_SET_ROW_DATA,
	ORDERLOCATIONS_SET_EDIT_DATA,
	MODEL_OPEN,
	MODEL_CLOSE,
	API_ERROR,
	SET_PARAMS,
	SELECT_CHANGEVALUE,
	INPUT_CHANGEVALUE,
	LOCATION_IMAGE,
	LOCATION_IMAGE2,
	LOCATION_IMAGE3,
	ORDERLOCATIONS_LIST_SUCCESSFUL,
	ORDERLOCATIONS_ADD_SUCCESSFUL,
	GET_Location_ROW_DATA,
	Location_ROW_SUCCESSFUL,
	CLEAR_ORDERLOCATION_DATA,
	ORDERLOCATIONS_EDIT_SUCCESSFUL
} from "./actionTypes";
const initialState = {
	error: "Sorry! No Data Found.",
	message: null,
	loading: false,
	rowlist: [],
	error_msg: null,
	rowdata: {},
	image: {},
	image2: {},
	image3: {},
	params: {
		no_of_pages: 0,
		page_size: 10,
		page: 1,
		search: "",
		currentSort: "code",
		sortOrder: "-",
	},
};

const orderLocations = (state = initialState, action) => {
	switch (action.type) {
		case ORDERLOCATIONS:
			state = {
				...state,
				loading: true,
			};
			break;
		case ORDERLOCATIONS_LIST_SUCCESSFUL:
			var noofpages = Math.ceil(
				action.payload.response.count / state.params.page_size
			);
			state = {
				...state,
				rowlist: action.payload.response.results,
				loading: false,
				params: {
					...state.params,
					no_of_pages: noofpages,
				},
			};
			break;
		case INPUT_CHANGEVALUE:
			state = {
				...state,
				rowdata: {
					...state.rowdata,
					[action.payload.key]: action.payload.value,
				},
			};
			break;

		case CLEAR_ORDERLOCATION_DATA:
			return {
				...state,
				rowdata: {},
				image: null,
				image2: null,
				image3: null,
			};

		case SELECT_CHANGEVALUE:
			state = {
				...state,
				rowdata: {
					...state.rowdata,
					[action.payload.key]: action.payload.label,
					[action.payload.key2]: action.payload.value,
				},
			};
			break;

		case LOCATION_IMAGE:
			state = {
				...state,
				image: action.payload.image,
			};
			break;

		case LOCATION_IMAGE2:
			state = {
				...state,
				image2: action.payload.image,
			};
			break;

		case LOCATION_IMAGE3:
			state = {
				...state,
				image3: action.payload.image,
			};
			break;

		case ORDERLOCATIONS_ADD:
			state = {
				...state,
				loading: true,
			};
			break;

		case ORDERLOCATIONS_ADD_SUCCESSFUL:
			state = {
				...state,
				message: action.payload,
				loading: false,
				model: false,
			};
			break;
		case GET_Location_ROW_DATA:
			state = {
				...state,
				loading: true,
			};
			break;
		case Location_ROW_SUCCESSFUL:
			state = {
				...state,
				rowdata: action.payload.response,
				loading: false,
			};
			break;

		case ORDERLOCATIONS_DELETE:
			state = {
				...state,
				loading: false,
			};
			break;

		case MODEL_OPEN:
			state = {
				...state,
				model: true,
			};
			break;
		case MODEL_CLOSE:
			state = {
				...state,
				model: false,
			};
			break;
		case SET_PARAMS:
			state = {
				...state,
				params: action.payload,
			};
			break;

		case ORDERLOCATIONS_EDIT:
			state = {
				...state,
				model: true,
				rowdata: action.payload,
			};
			break;
		case ORDERLOCATIONS_EDIT_SUCCESSFUL:
			state = {
				...state,
				loading: false,
				rowdata: { Id: 0 },
			};
			break;
		case API_ERROR:
			state = {
				...state,
				loading: false,
				error_msg: action.payload,
			};
			break;

		default:
			state = { ...state };
			break;
	}
	return state;
};

export default orderLocations;
